import { mapExchange } from 'urql';
const IDEMPOTENCY_HEADER = 'Idempotency-Key';
const normalizeHeaders = (init) => {
    if (!init)
        return {};
    if (init instanceof Headers) {
        const out = {};
        init.forEach((value, key) => {
            out[key] = value;
        });
        return out;
    }
    if (Array.isArray(init)) {
        return Object.fromEntries(init);
    }
    return { ...init };
};
export const idempotencyExchange = mapExchange({
    onOperation(operation) {
        const key = operation.context.idempotencyKey;
        if (typeof key !== 'string' || !key)
            return operation;
        const existing = operation.context.fetchOptions;
        const resolvedExisting = typeof existing === 'function' ? existing() : (existing ?? {});
        return {
            ...operation,
            context: {
                ...operation.context,
                fetchOptions: {
                    ...resolvedExisting,
                    headers: {
                        ...normalizeHeaders(resolvedExisting.headers),
                        [IDEMPOTENCY_HEADER]: key,
                    },
                },
            },
        };
    },
});
